import { VALIDATOR_PATTERNS } from "src/app/helper/class/app-constant";
import { formBuilder, formBuilderData, formDynamicValidator } from "src/app/helper/interface/response";

export const PROFILE_FORM: formBuilder[] = [
    {
        colName: 'user_id', title: '', hidden: true,
        event: { 'isCallback': true, 'name': 'change' }
    },
    {
        colName: 'fname',
        title: 'First Name *',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'lname',
        title: 'Last Name',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'email_id',
        title: 'Email Id',
        validator: [{ name: 'required' }, { name: 'email' }]
    },
    {
        colName: 'mobile_no',
        title: 'Mobile No',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
    },
    // {
    //     colName: 'password',
    //     title: 'password',
    //     type: 'PASSWORD'
    // },
    {
        colName: 'gender',
        title: 'Gender',
        type: 'select',
        selectKeyName: 'genderName',
        data: [{ genderName: 'Male', id: 1 }, { genderName: 'Female', id: 2 }]
    },
    {
        colName: 'avatar',
        title: 'Profile',
        type: 'FILE',
        // fileConfig: { fileType: 'IMAGE', 'label': 'Profile Image', filePath: '' }
    }
]

export const USER_FORM: formBuilder[] = [
    {
        colName: 'user_id', title: '', hidden: true,
        event: { 'isCallback': true, 'name': 'change' }
    },
    {
        colName: 'fname',
        title: 'First Name *',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'lname',
        title: 'Last Name',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'email_id',
        title: 'Email Id',
        validator: [{ name: 'required' }, { name: 'email' }]
    },
    {
        colName: 'mobile_no',
        title: 'Mobile No',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
    },
    {
        colName: 'password',
        title: 'password',
        type: 'PASSWORD'
    },
    {
        colName: 'gender',
        title: 'Gender',
        type: 'select',
        selectKeyName: 'genderName',
        data: [{ genderName: 'Male', id: 1 }, { genderName: 'Female', id: 2 }]
    },
    {
        colName: 'role_id', title: 'User Role', apiTblName: 'role', type: 'select', selectKeyName: 'roleName',
        validator: [{ name: 'required', error: '' }]
    },
    {
        colName: 'is_doctor',
        title: 'Is Doctor',
        type: 'checkbox',
        selectKeyName: 'is_doctorName',
        data: [{ is_doctorName: 'Yes', id: 1 }],
        event: { 'isCallback': true, 'name': 'change' }
    },
    { colName: 'counter_fk_id', title: 'Counter', type: 'select', apiTblName: 'counter', selectKeyName: 'counterName' },
    {
        colName: 'specialization',
        title: 'Specialization'
    },
    {
        colName: 'avatar',
        title: 'Profile',
        type: 'FILE',
        // fileConfig: { fileType: 'IMAGE', 'label': 'Profile Image', filePath: '' }
    }
]
export const USER_DYNAMIC_VALIDATOR: formDynamicValidator[] = [{
    controlName: 'is_doctor',
    validatorControl: ['specialization', 'counter_fk_id'],
    hideControl: ['specialization', 'counter_fk_id'],
    validator: [{ name: 'required' }],
    value: 1,
    operation: '=='
},
    // {
    //     controlName: 'user_id',
    //     validatorControl: ['password'],
    //     validator: [{ name: 'required' }],
    //     value: 1,
    //     operation: '>'
    // }
]

export const USER_INFO: formBuilderData[] = [
    {
        colName: 'fname',
        title: 'Name'
    },
    {
        colName: 'email_id',
        title: 'Email Id'
    },
    {
        colName: 'mobile_no',
        title: 'Mobile No'
    },
    {
        colName: 'roleName',
        title: 'Role Name'
    },
    {
        colName: 'last_login_date',
        title: 'Last login',
        type: 'DATE'
    },
    {
        colName: 'updated_at',
        title: 'Last update',
        type: 'DATE'
    }
]